import {
    App, Button, Skeleton, Flex, Form
} from 'antd';
import {
  WarningOutlined
} from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import { getMaintenanceRequests, getMaintenanceRecalls, getMaintenanceServices, getHistory, 
         getJobsAwaitingDriverReview, getJobItemStatuses, getJobReviewRequestOverridden } from "../../api/maintenance";
import { imageLocations } from "../image/ImageLocations";
import PanelFrameWithImage from "./PanelFrameWithImage";
import React, {useEffect, useState} from "react";
import { showApiError } from "../../utility/error/error-handler";
import { getDriver } from '../../api/driver';
import { getLastOdo, getVehicleAncillaries } from '../../api/vehicle';
import dayjs from 'dayjs';
import ServicesCardView from '../../sections/maintenance/ServicesCardView';
import RecallsCardView from '../../sections/maintenance/RecallsCardView';
import JobCardView from '../../sections/maintenance/JobCardView';
import JobHistoryView from '../../sections/maintenance/JobHistoryView';
import SummaryTabbedCanvas from '../../sections/maintenance/SummaryTabbedCanvas';
import JobAwaitingReview from '../../sections/maintenance/JobAwaitingReview';
import ReviewJobTask from '../../sections/maintenance/ReviewJobTask';
import SubmitOrViewMaintenanceRequests from '../../sections/maintenance/SubmitOrViewMaintenanceRequests';
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";
import {useOutletContext} from "react-router-dom";


const ManageMaintenancePanel = ({vehicle, backgroundType, refreshPage, setRefreshPage, maintRequestsModalVisible, setMaintRequestsModalVisible, motPreselected, setMotPreselected}) => {

    const [loadingProgress, setLoadingProgress] = useState(0);  //start 0 - button shows loading if less than 100
    const [submitProgress, setSubmitProgress] = useState(100);  //start 100 - button shows loading if less than 100
    const [maintenanceRequests, setMaintenanceRequests] = useState(null);
    const [loading, setLoading] = useState(true);
    const [driver, setDriver] = useState({});
    const { t } = useTranslation();
    const { isOnline } = useOnlineStatus();
    const { message, notification } = App.useApp();
    const [nextService, setNextService] = useState(vehicle?.nextMaintenanceService);
    const [lastJob, setLastJob] = useState(vehicle?.lastMaintenanceJob);
    const initialFromDate = dayjs().subtract(1, 'month');
    const [fromDate, setfromDate] = useState(dayjs().subtract(1, 'month'));
    const [toDate, setToDate] = useState(dayjs());
    const [hasRefreshedPreviousMonthsData, setHasRefreshedPreviousMonthsData] = useState(false);
    const [maintenanceRecalls, setMaintenanceRecalls] = useState(null);
    const [isViewRecallModalVisible, setIsViewRecallModalVisible] = useState(false);
    const [isEligibleForRecall, setIsEligibleForRecall] = useState(vehicle?.isEligibleForRecall);
    const [navigatedFromRecalls, setNavigatedFromRecalls] = useState(false);
    const [lastOdo, setLastOdo] = useState(null);
    const [hasSubmittedRequest, setHasSubmittedRequest] = useState(false);
    const [isViewServiceModalVisible, setIsViewServiceModalVisible] = useState(false);
    const [isViewHistoryModalVisible, setIsViewHistoryModalVisible] = useState(false);
    const [navigatedFromServices, setNavigatedFromServices] = useState(false);
    const [maintenanceServices, setMaintenanceServices] = useState(null);
    const [history, setHistory] = useState(null);
    const [historyItem, setHistoryItem] = useState(null);
    const [currentTab, setCurrentTab] = useState('createrequest');
    const [mainTab, setMainTab] = useState('overview');
    const [jobsAwaitingReview, setJobsAwaitingReview] = useState(null);
    const [selectedReviewRequest, setSelectedReviewRequest] = useState(null);
    const isEligibleForMOT = vehicle != null && vehicle.isEligibleForMOT ? vehicle.isEligibleForMOT : false;
    const [isViewReviewRequestModalVisible, setIsViewReviewRequestModalVisible] = useState(false);
    const [taskBeingReviewed, setTaskBeingReviewed] = useState(null);
    const [reviewForm] = Form.useForm();
    const [jobItemStatuses, setJobItemStatuses] = useState([]);
    const [vehicleAncillaries, setVehicleAncillaries] = useState(null);
    const [currentRequest, setCurrentRequest] = useState( {} );

    const context = useOutletContext();
    const permissions = context.permissions;

    const Buttons = ({currentTab}) => {
      const { t } = useTranslation();
      return (
        <div>
            <Flex gap="small" wrap>
               {(currentTab === 'services') ? <Button loading={loadingProgress !== 100 && !vehicle} onClick={(e) => viewServicesButton(e)}>{t('action.view_schedule')}</Button>:<></>}
               {(currentTab === 'history') ? <Button loading={loadingProgress !== 100 && !vehicle} onClick={(e) => viewHistoryButton(e)}>{t('action.view_history')}</Button>:<></>}
               {
               isOnline
               ?
               <Button type="primary" loading={loadingProgress !== 100 && !vehicle} onClick={(e) => clickCreateNewRequestButton(e)}>
                 {t('title.booking_requests')}
               </Button>
               :
               <></>
               }              
            </Flex>
        </div>
      );
    } 

    const clickCreateNewRequestButton = (e) => {
        if (vehicle && fromDate && toDate)
        {
            getMaintenanceRequests(vehicle.vehicleId, fromDate, toDate, setLoadingProgress)
                .then(res => {
                    setMaintenanceRequests(res);
                    setMaintRequestsModalVisible(true);  //open requests popup
                },)
                .catch(err => {
                    showApiError(t('title.view_maintenance_requests'), err, notification);
                });
        }
    };

    const viewRecallsButton = (e) => {
      setIsViewRecallModalVisible(true);
    };

    const viewServicesButton = (e) => {
      setIsViewServiceModalVisible(true);
    };  

    const viewHistoryButton = (e) => {
      getHistory(vehicle.vehicleId, setLoadingProgress)
        .then(res => {
          setHistory(res)
        })
        .catch(err => {
          showApiError(t('title.history'), err, notification);
        });
      setIsViewHistoryModalVisible(true);
    }; 
    
    const viewPendingReviewJobDetails = (e, request) => {
      if (request)
      {
        getJobReviewRequestOverridden(request.id, setLoadingProgress)
        .then(res => {
          notification.destroy();

          if (res.result) 
          {
            notification.open({
              icon: <WarningOutlined style={{color: 'var(--dp-status-colour-warning)'}}/>,
              description: t('message.review_no_longer_required'),
              duration: null,
            });
            setRefreshPage(true);        
          }
          else
          {
            setSelectedReviewRequest(request);
          }
        }, )
        .catch(err => {
             showApiError(t('title.new_booking_request'), err, notification);
             });
      }
    };    

    const editJobTask = (taskBeingReviewed) => {
      reviewForm.resetFields();

      // Enables update of the review popup form
      reviewForm.setFieldsValue({reviewOutcome: taskBeingReviewed?.reviewOutcome, note: taskBeingReviewed?.reviewNote});
      setTaskBeingReviewed(taskBeingReviewed);
      setIsViewReviewRequestModalVisible(true);
    }

    useEffect(() => {
            getDriver()
                .then(res => {
                    setLoading(false);
                    setDriver(res);
                },)
                .catch(err => showApiError(t('title.new_booking_request'), err, notification));
            setRefreshPage(false);
      }, [t, notification, refreshPage, setRefreshPage]);

    useEffect(() => {
      if (vehicle)
      {
        getMaintenanceRecalls(vehicle.vehicleId, setLoadingProgress)
        .then(res => {
          setMaintenanceRecalls(res);
        },)
        .catch(err => {
            showApiError(t('title.recalls'), err, notification);
          });
      }
      setRefreshPage(false);
  }, [t, notification, vehicle, refreshPage, setRefreshPage]);   
  
  useEffect(() => {
    if (vehicle)
    {
      getLastOdo(vehicle.vehicleId, setLoadingProgress)
      .then(res => {
          setLastOdo(res);
      }, )
      .catch(err => {
           showApiError(t('title.new_booking_request'), err, notification);
           });
    }
    setRefreshPage(false);
  }, [t, notification, vehicle, hasSubmittedRequest, refreshPage, setRefreshPage]);  

  useEffect(() => {
    if (vehicle)
    {
      getMaintenanceServices(vehicle.vehicleId, setLoadingProgress)
        .then(res => {
          setMaintenanceServices(res);
      },)
      .catch(err => {
            showApiError(t('title.service_schedule'), err, notification);
      });          
    }
    setRefreshPage(false);
  }, [t, notification, vehicle, refreshPage, setRefreshPage]);   

  useEffect(() => {
    setNextService(vehicle?.nextMaintenanceService);
    setLastJob(vehicle?.lastJob);
    setIsEligibleForRecall(vehicle?.isEligibleForRecall);
  }, [vehicle]);

  useEffect(() => {
    if (vehicle)
    {
      getJobsAwaitingDriverReview(vehicle.vehicleId, setLoadingProgress)
      .then(res => {
        setJobsAwaitingReview(res);
      },)
      .catch(err => {
          showApiError(t('title.jobs_awaiting_review'), err, notification);
        });
    }
    setRefreshPage(false);
  }, [t, notification, vehicle, refreshPage, setRefreshPage]);

  useEffect(() => {
    getJobItemStatuses().then(res => {
      setJobItemStatuses(res);
    })
    .catch(err => showApiError(t('title.job_items'), err, notification));
    
}, [t, notification, vehicle]);

useEffect(() => {
  if (vehicle)
  {
    getVehicleAncillaries(vehicle.vehicleId)
      .then((res) => {
        setVehicleAncillaries(res);
      })
      .catch(err => showApiError(t('title.vehicle_details'), err, notification));
  }
  setRefreshPage(false);
},[vehicle, t, notification, refreshPage, setRefreshPage]);   



  const hasOlderMaintenanceRequests = vehicle != null && vehicle.hasMaintenanceRequests && maintenanceRequests?.length === 0 ? vehicle.hasMaintenanceRequests : false;

  const resetAndCloseWindow = () => {
    if (hasRefreshedPreviousMonthsData)
    {
      setfromDate(initialFromDate);
    }

    setMaintRequestsModalVisible(false);
  }

  const refreshPreviousMonthsRequests = () => {
      const adjustedDate = dayjs(fromDate).subtract(1, 'month');
      setfromDate(adjustedDate);
      if (vehicle && adjustedDate && toDate)  //using filtered date as from date slow to update state
      {
          getMaintenanceRequests(vehicle.vehicleId, adjustedDate, toDate, setLoadingProgress)
              .then(res => {
                  setMaintenanceRequests(res);
                  setHasRefreshedPreviousMonthsData(true);   //refresh list
              },)
              .catch(err => {
                  showApiError(t('title.view_maintenance_requests'), err, notification);
              });
      }
  }

  
  return (
         <div> 
          {
            permissions.includes("DRIVERS_PORTAL_MAINTENANCE_VIEW")
            ?
            <PanelFrameWithImage title={t('title.maintenance_and_servicing')}
                               imageLocation={imageLocations.MAINTENANCE_AND_SERVICING_IMAGE}
                               backgroundType={backgroundType} height="260px"
                               buttons={<Buttons currentTab={mainTab}/>}
            >
            {
             vehicle //basing on just main object and not having 'loadingProgress === 100' as jumpy at end of load when goes to 0
             ? // Show/Submit Maintenance Requests
             <div>
                {/* This tabbed canvas component allows a driver to be able to view various maintenance aspects i.e. summary data/recalls/services */}                                       
                <SummaryTabbedCanvas setMainTab={setMainTab}
                                     isEligibleForRecall={isEligibleForRecall}
                                     viewRecallsButton={viewRecallsButton}
                                     nextService={nextService}
                                     viewPendingReviewJobDetails={viewPendingReviewJobDetails}
                                     maintenanceServices={maintenanceServices}
                                     maintenanceRecalls={maintenanceRecalls}
                                     lastJob={lastJob}
                                     jobsAwaitingReview={jobsAwaitingReview}
                                     permissions={permissions}
                                     setHistoryItem={setHistoryItem}
                >
                </SummaryTabbedCanvas>
             </div>
             : // Loading
             <div>
                <Skeleton active title={false} paragraph={{ rows: 4 }} />
             </div>
            }
            </PanelFrameWithImage>
            :
            <></>      
          }
          
          {/* This component displays a tabbed canvas that allows one to create and/or view maintenance request */}
          <SubmitOrViewMaintenanceRequests vehicle={vehicle}
                                            nextService={nextService}
                                            isModalVisible={maintRequestsModalVisible}
                                            setIsModalVisible={setMaintRequestsModalVisible}
                                            setNavigatedFromRecalls={setNavigatedFromRecalls}
                                            setNavigatedFromServices={setNavigatedFromServices}
                                            notification={notification}
                                            currentTab={currentTab}
                                            setCurrentTab={setCurrentTab}
                                            maintenanceRequests={maintenanceRequests}
                                            refreshPreviousMonthsRequests={refreshPreviousMonthsRequests}
                                            resetAndCloseWindow={resetAndCloseWindow}
                                            hasOlderMaintenanceRequests={hasOlderMaintenanceRequests}
                                            submitProgress={submitProgress}
                                            isEligibleForMOT={isEligibleForMOT}
                                            isEligibleForRecall={isEligibleForRecall}
                                            setSubmitProgress={setSubmitProgress}
                                            message={message}
                                            setToDate={setToDate}
                                            setHasSubmittedRequest={setHasSubmittedRequest}
                                            setRefreshPage={setRefreshPage}
                                            loading={loading}
                                            navigatedFromServices={navigatedFromServices}
                                            navigatedFromRecalls={navigatedFromRecalls}
                                            lastOdo={lastOdo}
                                            driver={driver}
                                            motPreselected={motPreselected}
                                            setMotPreselected={setMotPreselected}
                                            vehicleAncillaries={vehicleAncillaries}
                                            currentRequest={currentRequest}
                                            setCurrentRequest={setCurrentRequest}
          > 
          </SubmitOrViewMaintenanceRequests>
              
          {/* This component allows one to view only active maintenance recalls */}
          <RecallsCardView vehicle = {vehicle} 
                            isViewRecallModalVisible={isViewRecallModalVisible} 
                            setIsViewRecallModalVisible={setIsViewRecallModalVisible}
                            maintenanceRecalls={maintenanceRecalls}
                            setNavigatedFromRecalls={setNavigatedFromRecalls}
                            clickCreateNewRequestButton={clickCreateNewRequestButton}
                            loadingProgress={loadingProgress}
          >
          </RecallsCardView>                    

          {/* This component allows one to view maintenance service schedules */}                    
          <ServicesCardView vehicle = {vehicle}
                            notification = {notification}
                            isViewServiceModalVisible={isViewServiceModalVisible}
                            services={maintenanceServices}
                            setIsViewServiceModalVisible={setIsViewServiceModalVisible}
                            setNavigatedFromServices={setNavigatedFromServices}
                            clickCreateNewRequestButton={clickCreateNewRequestButton}
          > 
          </ServicesCardView>  

          {/* This component allows one to view the details of a maintenance history item */}
          <JobCardView historyItem={historyItem} setHistoryItem={setHistoryItem}> </JobCardView>

          {/* This component allows one to view maintenance history */}
          <JobHistoryView vehicle = {vehicle}
                          history={history}
                          isViewHistoryModalVisible={isViewHistoryModalVisible} 
                          lastJob={lastJob}
                          historyItem={historyItem}
                          loadingProgress={loadingProgress}
                          setIsViewHistoryModalVisible={setIsViewHistoryModalVisible}
                          clickCreateNewRequestButton={clickCreateNewRequestButton}
                          setHistoryItem={setHistoryItem}
          > 
          </JobHistoryView>

          {/* This component allows one to view job details of that job awaiting driver review */}
          <JobAwaitingReview vehicle={vehicle}
                              selectedReviewRequest={selectedReviewRequest}
                              setSelectedReviewRequest={setSelectedReviewRequest}
                              editJobTask={editJobTask}
                              jobItemStatuses={jobItemStatuses}
                              setRefreshPage={setRefreshPage}
                              setSubmitProgress={setSubmitProgress}
                              submitProgress={submitProgress}
          >
          </JobAwaitingReview>

          {/* This component allows one to review a job item task */}
          <ReviewJobTask vehicle={vehicle}
                          isViewReviewRequestModalVisible={isViewReviewRequestModalVisible}
                          selectedReviewRequest={selectedReviewRequest}
                          setSelectedReviewRequest={setSelectedReviewRequest}
                          taskBeingReviewed={taskBeingReviewed}
                          setIsViewReviewRequestModalVisible={setIsViewReviewRequestModalVisible}
                          form={reviewForm}
                          jobItemStatuses={jobItemStatuses}
          > 
          </ReviewJobTask>
         </div>
    );
}    

export default ManageMaintenancePanel;